module.exports = __webpack_public_path__ + "img/diamonds-3-new-2.9122a8d0.svg";